import React from 'react';


interface ExternalLinksProps {
  type: 'privacy' | 'terms' | 'blog';
}

export const ExternalLinks: React.FC<ExternalLinksProps> = ({ }) => {
  const links = [
    {
      text: "Google Privacy & Terms",
      url: "https://policies.google.com/"
    },
    {
      text: "Privacy International",
      url: "https://privacyinternational.org/"
    },
    {
      text: "Electronic Frontier Foundation",
      url: "https://www.eff.org/"
    }
  ];

  return (
    <div className="mt-12 border-t border-gray-100 pt-8">
      <h3 className="text-xl font-bold text-gray-900 mb-6">Additional Resources</h3>
      <ul className="grid gap-4">
        {links.map((link, index) => (
          <li key={index}>
            <a 
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center group p-3 -m-3 hover:bg-gray-50 rounded-lg transition-all duration-200"
            >
              <span className="text-gray-700 group-hover:text-primary-dark transition-colors">
                {link.text}
              </span>
              <svg 
                className="ml-2 w-4 h-4 text-gray-400 group-hover:text-primary-dark group-hover:translate-x-1 transition-all" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}; 